module.exports = __webpack_public_path__ + "img/krystal-grand.8aa35fe4.jpg";